import { PortalModalsActionTypes } from './portalModals.types';

const fetchRequest = () => ({ type: PortalModalsActionTypes.PORTAL_MODALS_FETCH_REQUEST });
const fetchSuccess = payload => ({ type: PortalModalsActionTypes.PORTAL_MODALS_FETCH_SUCCESS, payload });
const fetchFailure = () => ({ type: PortalModalsActionTypes.PORTAL_MODALS_FETCH_FAILURE });
const clear = () => ({ type: PortalModalsActionTypes.PORTAL_MODALS_CLEAR });

const actions = {
  fetch: {
    request: fetchRequest,
    success: fetchSuccess,
    failure: fetchFailure,
  },
  clear,
};

export default actions;
